var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeaderLayout',[_c('div',{staticClass:"main-page-content"},[_c('h3',[_vm._v("数据监控：用户")]),_c('div',[_c('PieChart')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }